import Vuex from 'vuex';

import app from './modules/app';

export default new Vuex.Store({
  modules: {
    app: {
      namespaced: true,
      ...app,
    },
  },
});
